import type { GatsbyBrowser } from "gatsby"
import "./src/styles/global.css"
import { captureAttribution, defaultClassify, installLinkTracking, referralUrl } from "./gatsby-ui/lib/attribution"

// Attribution (sites/RFC-004 §9.1–9.3). The hunto_attr cookie is host-only here:
// tikaj.com cannot share .hunto.ai, so links to hunto.ai and Autopilot carry the
// record as ft_*/lt_* parameters, plus utm_source=tikaj&utm_medium=referral when
// the link has no UTM of its own.
const isHunto = (u: URL) => {
  const h = u.hostname.toLowerCase()
  return h === "hunto.ai" || h.endsWith(".hunto.ai")
}

/** cta_click destination: own CTAs (demo, contact, tools) and every link to Hunto. */
const classify = (u: URL): string | null => {
  if (!isHunto(u) || u.hostname.toLowerCase().startsWith("autopilot.")) return defaultClassify(u)
  const p = u.pathname.toLowerCase()
  if (/^\/(book-a-)?demo\/?/.test(p)) return "demo"
  if (/^\/tools\//.test(p)) return "tool"
  if (/^\/contact\/?/.test(p)) return "contact"
  return "hunto"
}

export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  installLinkTracking({
    decorateHosts: [],
    decorate: (u) => (isHunto(u) ? referralUrl(u.toString(), "tikaj") : null),
    classify,
  })

  if (typeof window !== "undefined" && 'requestIdleCallback' in window) {
    (window as any).requestIdleCallback(() => {
      import('@fontsource/inter/600.css')
      import('@fontsource/inter/700.css')
    }, { timeout: 3000 })
  }
}

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({ location }) => {
  if (typeof window !== "undefined" && !location.hash) {
    window.scrollTo(0, 0)
  }
  // First-touch / last-touch attribution cookie (hunto_attr, host-only)
  captureAttribution()
}
